import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import hubContactService from "services/hubContactService";

// List HubContact
export const useListHubContact = (payload, onSuccess, onError) => {
  const { t } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    ["hubContacts", params?.page, params?.columnFilter["filter[hub_id]"]],
    () => hubContactService.listHubContact(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("hubContact"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data.items || [],
          params: params,
          totalCount: data._meta ? data._meta.totalCount : data.items.length,
        };
      },
    }
  );
};

// Create HubContact
export const useCreateHubContact = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubContactService.createHubContact, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("hubContact"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("hubContact"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Detail HubContact
export const useDetailHubContact = (payload, onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useQuery(
    ["hubContact", "detail"],
    () => hubContactService.detailHubContact(payload),
    {
      enabled: false,
      retry: 1,
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.detail", {
                target: t("hubContact"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return data;
      },
    }
  );
};

// Update HubContact
export const useUpdateHubContact = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubContactService.updateHubContact, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("hubContact"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("hubContact"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Active HubContact
export const useActiveHubContact = (onSuccess, onError) => {
  const { t } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubContactService.updateHubContact, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;

      addToast(
        t("message.active", {
          target: t("hubContact"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.active", {
              target: t("hubContact"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Delete HubContact
export const useInactiveHubContact = (onSuccess, onError) => {
  const { t } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubContactService.updateHubContact, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;

      addToast(
        t("message.delete", {
          target: t("hubContact"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.delete", {
              target: t("hubContact"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Update HubContact
export const useDeleteHubContact = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["hub"]);
  const { addToast } = useToasts();

  return useMutation(hubContactService.deleteHubContact, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.remove", {
          target: t("hubContact"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.remove", {
              target: t("hubContact"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
